import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {BeneficiaireListPage} from './beneficiaire-list';
import {OauthService} from '../../shared/services/oauth.service';
import {BeneficiairesService} from '../../shared/services/beneficiaires.service';
import {CoreModule} from '../../core/core.module';
import {LocalStorageService} from '../../shared/services/localStorage.service';

@NgModule({
    declarations: [
        BeneficiaireListPage
    ],
    imports: [
        IonicPageModule.forChild(BeneficiaireListPage),
        CoreModule
    ],
    providers: [
        OauthService,
        BeneficiairesService,
        LocalStorageService
    ]
})
export class BeneficiaireListPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/beneficiaire-list/beneficiaire-list.module.ts